export const CHILD_TO_PARENT: Record<string, string> = {
  'weekly-schedule': 'attendance-calendar',
  'submit-request': 'attendance-calendar',
  'leave-requests': 'leave-management',
  'leave-balances': 'leave-management',
  'public-holidays': 'leave-management',
  desks: 'workspace',
  rooms: 'workspace',
  offices: 'workspace',
  projects: 'time-tracking',
  'time-entries': 'time-tracking',
  activities: 'time-tracking',
}

export const PLANNING_TAB_ORDER = [
  'attendance-calendar',
  'past-requests',
  'attendance',
  'leave-management',
  'workspace',
  'time-tracking',
]

export function expandPlanningTabs(allowed: string[]): Set<string> {
  const effective = new Set(allowed)
  for (const tab of allowed) {
    const parent = CHILD_TO_PARENT[tab]
    if (parent) effective.add(parent)
  }
  return effective
}

export function resolvePlanningPath(allowedTabs: string[]): string {
  const effective = expandPlanningTabs(allowedTabs)
  const first = PLANNING_TAB_ORDER.find((t) => effective.has(t))
  return `/user/planning/${first || 'attendance-calendar'}`
}

const PARENT_KEYS = new Set([
  'attendance-calendar', 'leave-management', 'workspace', 'time-tracking',
])

export function getParentTabOrder(allTabs: string[]): string[] {
  return allTabs.filter((t) => PARENT_KEYS.has(t))
}

const CHILD_MAP: Record<string, string[]> = {
  'attendance-calendar': ['weekly-schedule', 'submit-request'],
  'leave-management': ['leave-requests', 'leave-balances', 'public-holidays'],
  workspace: ['desks', 'rooms', 'offices'],
  'time-tracking': ['projects', 'time-entries', 'activities'],
}

export function getChildTabOrder(parentKey: string, allTabs: string[]): string[] {
  const children = CHILD_MAP[parentKey]
  if (!children) return []
  return allTabs.filter((t) => children.includes(t))
}
